"use client";
import PropTypes from "prop-types";
import { CardActionArea } from "@mui/material";
import { Card as StyledCard } from "./Card.styles";

const Card = ({ link, children, keyProp, disableZoom, ...rest }) => {
  const newChildren = link ? (
    <CardActionArea
      href={link}
      sx={{
        height: "100%",
      }}
    >
      {children}
    </CardActionArea>
  ) : (
    children
  );

  return (
    <StyledCard key={keyProp} disableZoom={disableZoom} {...rest}>
      {newChildren}
    </StyledCard>
  );
};

Card.propTypes = {
  link: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  keyProp: PropTypes.string,
  disableZoom: PropTypes.bool,
};

export default Card;
